import TemplateView from "../../TemplateView"
import messageResource from "../../messageResource"
import $ from "jquery"
import CopySettingsBlock from '../components/CopySettingsBlock'
import {getItemsForCopyCustomerSettingsBlock} from '../components/utils'
import InformationBlock from '../../components/informationBlock/InformationBlock'
import {EntityTextLimits} from 'constants'
import {trim} from '../../atUtils'

export default class CopyCustomerDialog extends TemplateView {
    constructor({
        onCopyCb = (customerName, settings) => {},
        onCancelCb = () => {},
    }) {
        super()

        this.state = {
            customerName: '',
            copyEnabled: false,

            canManageAccountsAndPermissions: false,
            isBTYEnabled: false,
            isESTEnabled: false,
            isTWSEnabled: false,
            isWASEnabled: false,

            hasSomeTeamAssignment: false,
        }

        this.callbacks = {
            onCopyCb,
            onCancelCb,
        }

        this.onStatePropertyChanged('customerName', (customerName) => {
            this.$title.text(messageResource.getMessage('customer.copy_dialog.title', [customerName]))
        })

        this.onAnyStatePropertyChanged(
            [
                'canManageAccountsAndPermissions',
                'isBTYEnabled',
                'isESTEnabled',
                'isTWSEnabled',
                'isWASEnabled',
                'hasSomeTeamAssignment'
            ], () => {
                this.copySettingsBlock.setState(
                    getItemsForCopyCustomerSettingsBlock(
                        this.state.canManageAccountsAndPermissions,
                        this.state.isBTYEnabled,
                    this.state.isESTEnabled,
                    this.state.isTWSEnabled,
                    this.state.isWASEnabled,
                    this.state.hasSomeTeamAssignment,
                )
            )
        })

        this.onStatePropertyChanged('copyEnabled', (enabled) => this.$el.toggleClass('actionEnabled', enabled))
    }

    templateHtml() {
        return "<div class='copyCustomerDialog moveToDialog'>" +
               "  <div class='title'></div>" +
               "    <div class='nameInput'>" +
               "        <input type='text' maxlength='<%=maxNameLength%>'/>" +
               "    </div>" +
               "  <div class='settingsBlockContainer'/>" +
               "  <div class='informationBlockContainer'/>" +
               "  <div class='buttonsContainer'>" +
               "    <div class='ok button'><%=copyLabel%></div>" +
               "    <div class='cancel button'><%=cancelLabel%></div>" +
               "  </div>" +
               "</div>"
    }

    messageKeys() {
        return {
            copyLabel: "edit_panel.action.copy",
            cancelLabel: "common.cancel",
        }
    }

    templateModel() {
        return {
            maxNameLength: EntityTextLimits.MAX_CPT_NAME,
        }
    }

    afterRender() {
        this.$title = this.find('.title')
        this.$input = this.find('input')

        this.$input.valueChanged(() => this.updateButton())
        this.$input.keyup(() => this.updateButton())

        this.find(".ok.button").click(() => {
            if (this.state.copyEnabled) {
                this.callbacks.onCopyCb(
                    trim(this.$input.pVal()),
                    this.copySettingsBlock.getSelectedSettings(),
                )
            }
        })

        this.find(".cancel.button").click(() => {
            $(this).trigger("cancel")
            this.callbacks.onCancelCb()
        })

        this.copySettingsBlock = new CopySettingsBlock().init(this.find('.settingsBlockContainer'))

        new InformationBlock({
            paragraphs: [
                messageResource.getMessage('customer.copy_dialog.info_paragraph'),
            ],
        }).init(this.find('.informationBlockContainer'))

        this.renderInitialState()
    }

    updateNewCustomerName(name) {
        this.$input.pVal(name)
        this.updateButton()
    }

    updateButton() {
        this.setState({
            copyEnabled: !!this.$input.pVal()
        })
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/customer/CopyCustomerDialog.js